<script setup lang="ts">
// Components
import ChronologicalTable from '../../components/table/chronological.vue';
import ChartBar from '../../components/chart/barChart.vue';
import ChartLine from '../../components/chart/lineChart.vue';

// Store
const { consumptionError, consumptionType, areasToCompare, comparisonError, loadingComparison, loadingConsumption } =
  storeToRefs(chronologicalStore());
const { getKeysFromForage } = useExploreStorage();
const { aggregationLevel } = storeToRefs(exploreStore());
const { loadChronologicalData } = useChronologicalService();

// Composables
const { t } = useI18n();

// Data
const buttonGroupItems = computed(() => {
  return [
    { key: 'consumption', label: t('global.consumption'), disabled: false },
    {
      key: 'production',
      label: t('explore.epi'),
      disabled: areasToCompare.value.length > 0 || ['hour', 'minute'].includes(aggregationLevel.value),
      tooltip: (() => {
        if (areasToCompare.value.length > 0) {
          return t('explore.tooltip_disabled_production_on_comparison');
        }
        if (['hour', 'minute'].includes(aggregationLevel.value)) {
          return t('explore.tooltip_disabled_production_on_aggregation_level');
        }
        return undefined;
      })(),
    },
  ];
});

const error = computed(() => {
  if (areasToCompare.value.length === 0) return consumptionError.value;
  return comparisonError.value;
});

const refreshData = () => {
  loadChronologicalData();
};

onMounted(async () => {
  await getKeysFromForage();
  loadChronologicalData();
});
</script>
<template>
  <div class="w-full h-full flex flex-col gap-4">
    <div class="flex-1 grid grid-rows-[1fr,auto] gap-4 min-h-0 w-full">
      <ui-card class="w-full h-full min-h-0 overflow-hidden">
        <div class="w-full h-full">
          <div v-if="error && (!loadingConsumption || !loadingComparison)" class="flex flex-col items-center justify-center h-[70vh]">
            <div class="flex flex-col items-center justify-center border border-gray-500 bg-gray-100 rounded-md p-4">
              <p class="text-gray-500 text-sm">{{ $t(`error.${error?.error_code ?? 'title'}`) }}</p>
              <ui-button
                v-if="error?.error_code === '2784cd7d-559b-491b-bece-c67af7196819'"
                left-icon="RefreshCcw"
                color="secondary"
                class="mt-4"
                @click="refreshData"
              >
                {{ $t('global.reload') }}
              </ui-button>
            </div>
          </div>
          <div v-else>
            <div class="flex justify-end mb-2">
              <nrjx-button-group v-model="consumptionType" :items="buttonGroupItems" />
            </div>
            <chart-bar v-if="['day', 'week', 'month'].includes(aggregationLevel)" :type="consumptionType" />
            <chart-line v-else />
          </div>
        </div>
      </ui-card>

      <ui-card v-if="areasToCompare.length === 0" class="w-full h-full min-h-0">
        <chronological-table />
      </ui-card>
    </div>
  </div>
</template>
